// ── Munkamenet-szintű API-cache (promise-cache) ──────────────────────────────
// Cél: ugyanazt a GET-adatot egy SPA-munkameneten belül ne kérjük le többször
// (route-váltás, vissza-gomb, több komponens ugyanarra az endpointra).
//
// Működés: kulcs = teljes URL. Az ELSŐ hívás a folyamatban lévő Promise-t
// tárolja el → az egyidejű (in-flight) és a TTL-en belüli ismételt hívások
// ugyanazt a Promise-t kapják (dedup). Hiba esetén a bejegyzés törlődik, így
// a következő hívás újra próbálkozik (hibát SOSEM cache-elünk).
//
// A TTL hívóhelyenként adható meg; teljes oldal-újratöltés úgyis üríti a
// cache-t (új JS-kontextus), tehát a frissesség felső korlátja a TTL és a
// session hossza közül a kisebb.

const _store = new Map(); // url -> { promise, ts }

export const DEFAULT_TTL_MS = 5 * 60 * 1000;

export function fetchJsonCached(url, { ttl = DEFAULT_TTL_MS } = {}) {
  const now = Date.now();
  const hit = _store.get(url);
  if (hit && now - hit.ts < ttl) return hit.promise;

  const promise = fetch(url)
    .then((r) => {
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      return r.json();
    })
    .catch((err) => {
      // Hibás/megszakadt kérés ne ragadjon a cache-ben – retry lehetséges.
      if (_store.get(url)?.promise === promise) _store.delete(url);
      throw err;
    });

  _store.set(url, { promise, ts: now });
  return promise;
}

/** Cache ürítése (admin-műveletek után / teszthez). */
export function clearApiCache() {
  _store.clear();
}
